import ContainedButton from "Components/HomeV2/Buttons/Contained";
import { OutlineButton } from "Components/HomeV2/Buttons";
import image from "../../Assets/TalentOnDemand/main-hero.png";

const TalentOnDemandMainHero = () => {
    return (
			<section className="w-full h-full bg-black flex flex-col items-center justify-between gap-4 pt-8 md:pt-20 ">
				<div className="px-4 lg:px-0">
					<h2 className="text-2xl md:text-5xl xl:text-7xl text-white font-semibold text-center flex items-start justify-center">
						Talent OnDemand
						<span className="text-xl md:text-3xl font-normal">&#8482;</span>
					</h2>
					<h4 className="text-center w-full mx-auto md:mx-0 md:w-fit text-white md:text-2xl mt-4">
						Hand-selected Candidates leveraging AI recruiting tech.
					</h4>
					<div className="flex  max-w-[180px] items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
						<a
							target="_blank"
							href="https://calendly.com/salesbox-meet/talent-ondemand-package"
							className="w-full "
						>
							<ContainedButton theme="primary">Book a call</ContainedButton>
						</a>
						<a href="/reach-out?services=build-my-team" className="w-full ">
                        <OutlineButton>What’s Inside</OutlineButton>
						</a>
					</div>
				</div>
				<div>
					<img
						src={image}
						alt="3 people standing together"
						width="100%"
						height="100%"
						loading="lazy"
					/>
				</div>
			</section>
		);
}

export default TalentOnDemandMainHero;